<template>
  <form class="auth-login-form" @submit.prevent="handleSubmit">
    <BaseInput
      class="mb-3"
      type="email"
      size="xl"
      id="loginEmail"
      placeholder="E-mail"
      v-model="$v.user.email.$model"
      :error="$v.user.email.$error"
      :message="emailErrorMessages"
    />

    <BaseInput
      class="mb-3"
      type="password"
      size="xl"
      id="loginPassword"
      placeholder="Senha"
      v-model="$v.user.password.$model"
      :error="$v.user.password.$error"
      :message="passwordErrorMessages"
    />

    <BaseButton
      class="mt-3"
      type="submit"
      size="xl"
      block
      :disabled="$v.user.$invalid || isSubmitting"
    >
      <span class="mr-2">Entrar</span>
      <BaseSpinner v-if="isSubmitting" variant="light" size="sm" />
    </BaseButton>

    <p class="auth-text auth-form-forgot-password">
      Esqueceu a senha? <a href="/recuperarSenha">Recuperar</a>
    </p>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'LoginForm',
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      redirectFrom: '',
    };
  },
  validations: {
    user: {
      email: { required, email },
      password: { required },
    },
  },
  mounted() {
    this.redirectFrom = this.$route.query.redirectFrom;
  },
  methods: {
    ...mapActions('auth', ['login']),

    async handleSubmit() {
      this.login({ ...this.user, redirectFrom: this.redirectFrom })
        .then((path) => {
          this.$router.push({ path })

          if (this.isDoctor)
            this.initMemed(this.getCurrentUser.doctor_property.memed_token);
        })
        .catch((error) => error);
    },
    initMemed(token) {
      let script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", "memed-script");
      script.setAttribute("data-color", "#1abc9c");
      script.setAttribute("data-token", token);
      script.setAttribute("data-container", "memed-container");
      script.src = process.env.VUE_APP_DOMINIO_API_MEMED;
      document.body.appendChild(script);
    }
  },
  computed: {
    ...mapGetters('auth', ['isSubmitting', 'redirectPathName']),
    ...mapGetters('user', ['getCurrentUser']),

    emailErrorMessages() {
      let errors = [];
      !this.$v.user.email.required && errors.push('E-mail é obrigatório');
      !this.$v.user.email.email && errors.push('E-mail é inválido');
      return errors;
    },
    passwordErrorMessages() {
      let errors = [];
      !this.$v.user.password.required && errors.push('Senha é obrigatória');
      return errors;
    },
    isDoctor() {
      return this.getCurrentUser.account_type == 'doctor'
    }
  },
};
</script>
